'use strict';
document.addEventListener('DOMContentLoaded', function() {
    var populationElements = document.querySelectorAll('.population');
    var totalElement = document.querySelector('.total-population');
    var averageElement = document.querySelector('.average-population');
    var populations = Array.from(populationElements).map(function(el) {
        return parseInt(el.textContent.replace(/,/g, ''), 10);
    });
    var total = populations.reduce(function(sum, pop) {
        return sum + pop;
    }, 0);
    var average = Math.round(total / populations.length);
    var formatNumber = function(pop) {
        return pop.toLocaleString('en-US');
    };
    totalElement.textContent = formatNumber(total);
    averageElement.textContent = formatNumber(average);
});

//# sourceMappingURL=js_get_data_DOM.a61065f4.js.map
